import { render, staticRenderFns } from "./LedgerMessage.vue?vue&type=template&id=4beb5018&"
import script from "./LedgerMessage.vue?vue&type=script&lang=js&"
export * from "./LedgerMessage.vue?vue&type=script&lang=js&"
import style0 from "./LedgerMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports